module.exports = __webpack_public_path__ + "public/SiteIcons/moreDeclineHover.svg?a111d5c2";